<template>
  <div
    class="pop-box"
    :class="{
      'flex-center': align === 'center',
      'flex-end': align === 'right',
    }">
    <span v-if="!list.length">
      <slot name="blank" v-if="$slots.blank" />
      <span v-else>-</span>
    </span>
    <el-popover
      v-else
      ref="pop"
      v-model="popShow"
      :disabled="list.length <= 1 && !alwaysShow"
      placement="bottom"
      :open-delay="200"
      :close-delay="200"
      :trigger="trigger"
      style="max-width: 100%"
    >
      <div v-if="popShow">
        <vxe-grid
          v-if="tableConfig"
          v-bind="{
            data: list,
            maxHeight: 300,
            ...tableConfig
          }"
        />
        <div v-else style="margin: -5px 0;">
          <div v-for="(item, index) in list" :key="index" style="margin: 5px 0;">
            <div v-if="countryCode">
              <span v-if="countryCode" v-amazon-href="{ asin: item, code: countryCode, noBlank }" />
              <span v-else>{{item || '-'}}</span>
            </div>
            <CountryImg v-else-if="isCountry" :code="item" />
            <span v-else>{{item}}</span>
          </div>
        </div>
      </div>
      <div class="subInfo-box" slot="reference">
        <div v-if="$slots.default" class="onHide">
          <TipsStr>
            <slot />
          </TipsStr>
        </div>
        <div v-else-if="countryCode">
          <span v-if="countryCode" v-amazon-href="{ asin: list[0], code: countryCode, noBlank }" />
          <span v-else>{{list[0]}}</span>
        </div>
        <div v-else-if="tableConfig" class="onHide">
          <div v-for="col in tableConfig.columns" :key="col.field">
            <div v-if="col.field === 'countryCode'"><CountryImg :code="list[0][col.field]" /></div>
            <TipsStr v-else :content="list[0][col.field]" />
          </div>
        </div>
        <CountryImg v-else-if="isCountry" :code="list[0]" />
        <TipsStr v-else :content="list[0]" />
        <i
          v-if="list.length > 1 || alwaysShow"
          class="ml05"
          :class="iconClass"
        />
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  props: {
    trigger: {
      type: String,
      default: 'hover',
    },
    align: {
      type: String,
      default: 'left',
    },
    list: {
      type: Array,
      default() {
        return []
      }
    },
    tableConfig: { // 表格配置
      type: Object,
      default() {
        return null
      }
    },
    isCountry: { // 是否为国家数组
      type: Boolean,
      default: false,
    },
    countryCode: String, // asin数组状态下的国家编码
    noBlank: { // asin数组状态下的是否新标签跳转， 默认false
      type: Boolean,
      default: false,
    },
    alwaysShow: { // 是否不受list长度控制，展示所有
      type: Boolean,
      default: false,
    },
    iconType: {
      type: String,
      default: 'down'
    }
  },
  watch: {
    popShow(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.pop && this.$refs.pop.updatePopper()
        }, 0)
      }
    }
  },
  computed: {
    iconClass() {
      switch (this.iconType) {
        case 'down':
          return 'el-icon-arrow-down g__common-btn-hover'
        default:
          return 'iconhuice icon-shouqi1'
      }
    }
  },
  data() {
    return {
      popShow: false
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.pop-box{
  display: flex;
}
.subInfo-box{
  display: flex;
  align-items: center;
  overflow: hidden;
  .subInfo-num{
    background-color: $G3;
    color: $main-text-color;
    padding: 0 5px;
  }
  .icon-shouqi1{
    color: $G7;
  }
}
</style>
